export type TimeUnit =
  | 'milliseconds'
  | 'seconds'
  | 'minutes'
  | 'hours'
  | 'days'
  | 'weeks'
  | 'months'
  | 'years'
  | 'millisecond'
  | 'second'
  | 'minute'
  | 'hour'
  | 'day'
  | 'week'
  | 'month'
  | 'year'
export const ms = (amount: number, unit: TimeUnit) => {
  switch (unit) {
    case 'milliseconds':
    case 'millisecond':
      return amount
    case 'seconds':
    case 'second':
      return amount * 1000
    case 'minutes':
    case 'minute':
      return amount * 1000 * 60
    case 'hours':
    case 'hour':
      return amount * 1000 * 60 * 60
    case 'days':
    case 'day':
      return amount * 1000 * 60 * 60 * 24
    case 'weeks':
    case 'week':
      return amount * 1000 * 60 * 60 * 24 * 7
    case 'months':
    case 'month':
      return amount * 1000 * 60 * 60 * 24 * 30
    case 'years':
    case 'year':
      return amount * 1000 * 60 * 60 * 24 * 365
  }
  throw new Error(`Unknown time unit: ${unit}`)
}
